/* eslint-disable no-useless-escape */
import { useForm } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router-dom";
import axiosInstance from "axios";
import { selected_authentication_server } from "../deployment-config";
import { Background } from "./Login/LoginComp";
import { LoadingButton } from "../Utils/CustomComponent";
import { toast } from "react-toastify";
import { commonToast } from "../Utils";
import FormBox from "../components/FormBox/FormBox";
import { updatedRegisterFormSchema } from "../Utils/formOptions";
import base64 from "base-64";
import React, { useEffect, useRef, useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import PasswordChecklist from "react-password-checklist";

const Register = () => {
  const [searchParams] = useSearchParams();
  const [otpEntered, setOtpEntered] = useState("");
  const email = searchParams.get("id");
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm(updatedRegisterFormSchema);

  const newPassword = watch("Password");
  const confirmPassword = watch("confirm_password");
  const [disableFWS, setDisableFWS] = useState();
  const [promptFail, setPromptFail] = useState(null);
  const [step2Validated, setStep2Validated] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (email && isValidBase64(email)) {
      const updatedEmail = base64.decode(email);
      if (isValidEmail(updatedEmail)) setValue("Email", updatedEmail);
    }
  }, [email, setValue]);
  const isValidBase64 = (str) => {
    try {
      return btoa(atob(str)) === str;
    } catch (err) {
      return false;
    }
  };
  const isValidEmail = (email) => {
    const emailRegex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailRegex.test(email);
  };
  const onSubmit = async (data) => {
    if (newPassword && confirmPassword) {
      if (newPassword !== confirmPassword) {
        setError("confirm_password", {
          type: "custom",
          message: "Passwords do not match",
        });
      } else {
        clearErrors("confirm_password");
        data.userid = localStorage.getItem("apex_userid");
        setDisableFWS(true);
        const id = toast.loading("Registering User");
        try {
          const res2 = await axiosInstance.post(
            selected_authentication_server.registerVerify.endpoint,
            {
              ...data,
              registrationCode: otpEntered,
            },
            selected_authentication_server.registerVerify.headers
          );
          if (res2) {
            const { error, status } = parseJSONObjects(res2.data)[0];
            if (error) {
              setPromptFail(error);
              toast.update(id, {
                render: error,
                type: "error",
                isLoading: false,
                ...commonToast,
              });
            }
            if (status === 200) {
              const res = await axiosInstance.post(
                selected_authentication_server.register.endpoint,
                { ...data, UserName: data.Email },
                selected_authentication_server.register.headers
              );
              if (res.data.status && res.data.status === "404") {
                setPromptFail(res.data.error[0].message);
                toast.update(id, {
                  render: res.data.error[0].message,
                  type: "error",
                  isLoading: false,
                  ...commonToast,
                });
              } else {
                setTimeout(() => {
                  navigate("/login");
                }, 3000);
                toast.update(id, {
                  render: "Registered Succesfuly",
                  type: "success",
                  isLoading: false,
                  ...commonToast,
                });
              }
            }
          }
        } catch (error) {
          console.error(error);
        } finally {
          setTimeout(() => {
            toast.dismiss();
            setDisableFWS(false);
          }, 1000);
        }
      }
    }
  };
  const isValid = isValidBase64(email) && isValidEmail(base64.decode(email));
  return (
    <Background>
      <form className="w-75">
        <h3>Register</h3>
        <p className="pb-5 mb-3">Enter your Details to proceed</p>
        <FormBox
          options={registerFormArr(
            disableFWS,
            !!isValid,
            newPassword,
            confirmPassword,
            setStep2Validated
          )}
          register={register}
          watch={watch}
          setValue={setValue}
          errors={errors}
        />
        <div className="form-outline mb-1">
          <OTPInputComponent setOtpEntered={setOtpEntered} />
        </div>
        <div className="row mt-2">
          <div className="col text-center mt-5 mb-5 pb-1">
            <LoadingButton
              className="btn btn-primary w-100 btn-block fa-lg gradient-custom-2 mb-3 text-white"
              type="button"
              onClick={handleSubmit(onSubmit)}
              disabled={disableFWS}
              loading={disableFWS}
              title="Register"
            />
            {promptFail && (
              <div className="alert alert-error" role="alert">
                {promptFail}
              </div>
            )}
            <br />
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-center p-4">
          <div className="mb-0 me-3">Already a User?</div>
          <div
            role="button"
            className="linkClick cursor-pointer"
            onClick={() => {
              navigate("/Login");
            }}
          >
            Login
          </div>
        </div>
      </form>
    </Background>
  );
};
export default Register;
function parseJSONObjects(str) {
  const objects = [];
  let startPos = 0;
  let braceCounter = 0;

  for (let i = 0; i < str?.length; i++) {
    const char = str[i];
    if (char === "{") {
      if (braceCounter === 0) startPos = i;
      braceCounter++;
    } else if (char === "}") {
      braceCounter--;
      if (braceCounter === 0) {
        // When a complete object is identified, try to parse it
        const objStr = str.substring(startPos, i + 1);
        try {
          const obj = JSON.parse(objStr);
          objects.push(obj);
        } catch (error) {
          console.error("Error parsing JSON:", error);
        }
      }
    }
  }

  return objects;
}
const registerFormArr = (
  disableFWS,
  isValid,
  newPassword,
  confirmPassword,
  setStep2Validated
) => [
  {
    title: "First Name",
    field: "firstName",
    type: "text",
    className: "col-12",
    disable: disableFWS,
  },
  {
    title: "Last Name",
    field: "lastName",
    type: "text",
    className: "col-12",
    disable: disableFWS,
  },
  {
    title: "Email",
    field: "Email",
    type: "email",
    className: "col-12",
    disable: disableFWS || isValid,
  },
  {
    title: "New Password",
    field: "Password",
    type: "text",
    className: "col-12",
    eyeIcon: true,
  },
  {
    title: "Confirm New Password",
    field: "confirm_password",
    type: "text",
    className: "col-12",
    eyeIcon: true,
  },
  {
    type: "content",
    content: (
      <PasswordChecklist
        rules={[
          "minLength",
          "specialChar",
          "number",
          "capitalAndLowercase",
          "match",
          "noSequence",
        ]}
        minLength={8}
        maxLength={30}
        value={newPassword || ""}
        valueAgain={confirmPassword}
        onChange={(isValid) => {
          if (isValid) setStep2Validated(true);
          else setStep2Validated(false);
        }}
        messages={{
          minLength: "Contain 8 to 30 characters",
          capitalAndLowercase: "Contain both lower and uppercase letters",
          number: "Contain 1 number",
          specialChar: "Contain 1 special character - !@#$%^&*()_+",
          noSequence:
            "Not contain letter or number sequences like 'abc', '123', '4444', 'qwerty'",
        }}
        customRules={{
          noSequence: (password) => {
            // Disallow common sequences like 'abc', '123', '4444', 'qwerty'
            const disallowedPatterns = [
              /(abc|123|qwerty)/i,
              /(.)\1\1\1/, // Repeating characters like "4444"
            ];
            return !disallowedPatterns.some((pattern) =>
              pattern.test(password)
            );
          },
        }}
      />
    ),
    className: "col-12",
  },
  {
    title: "Mobile",
    field: "Mobile",
    type: "phoneNumber",
    className: "col-12 mb-3",
    disable: disableFWS,
  },
  // {
  //   title: "Register Code",
  //   field: "registrationCode",
  //   type: "text",
  //   className: "col-12",
  //   disable: disableFWS,
  // },
];

const OTPInputComponent = ({ setOtpEntered }) => {
  const length = 6; // Length of OTP
  const [otp, setOtp] = useState(new Array(length).fill(""));
  const inputsRef = useRef(new Array(length).fill(React.createRef()));

  const handleChange = (element, index) => {
    if (isNaN(element.value)) return false; // If not a number, don't process

    // Update OTP array
    const newOtp = [
      ...otp.map((d, idx) => (idx === index ? element.value : d)),
    ];
    setOtp([...newOtp]);
    setOtpEntered(newOtp.join(""));

    // Focus next input on value entry, previous if empty (backspace/delete)
    if (element.value !== "") {
      // Move to next input if available
      if (element.nextSibling) {
        element.nextSibling.focus();
      }
    } else if (element.previousSibling) {
      // Move to previous input on backspace/delete if available
      element.previousSibling.focus();
    }
  };

  useEffect(() => {
    // Automatically focus the first input on component mount
    inputsRef.current[0].focus();
  }, []);

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData
      .getData("text/plain")
      .slice(0, length)
      .split("");
    if (pastedData?.length === length) {
      setOtp([...pastedData]);
      setOtpEntered(pastedData.join(""));
      inputsRef.current[length - 1].focus();
    }
  };

  return (
    <>
      <label>Please Enter Your 6-Digit Registration Code:</label>
      <InputGroup className="gap-5 mt-5">
        {Array.from({ length }, (_, index) => (
          <Form.Control
            key={index}
            type="text"
            maxLength="1"
            style={{
              width: "3rem",
              textAlign: "center",
              borderRadius: "0.25rem",
            }}
            value={otp[index]}
            onChange={(e) => handleChange(e.target, index)}
            onKeyDown={(e) => {
              // When the user presses backspace and the input is empty, focus the previous input
              if (e.key === "Backspace" && !otp[index]) {
                const prevInput = inputsRef.current[index - 1];
                if (prevInput) {
                  prevInput.focus();
                }
              }
            }}
            onPaste={handlePaste}
            ref={(ref) => (inputsRef.current[index] = ref)}
            className="inputStyle form-control input-lg p-5"
          />
        ))}
      </InputGroup>
    </>
  );
};
